<template>
  <div class="c-filter">
    <ElForm label-width="40" inline class="elementui-common-form-styles" v-highlight>
      <ElFormItem label="账号">
        <el-select v-model="accountId" multiple collapse-tags filterable placeholder="全部">
          <el-option v-for="act in MEDIA_ACCOUNTS" :key="act.id" :value="act.id" :label="act.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="平台">
        <el-select v-model="platform" style="width: 100px" placeholder="全部">
          <el-option v-for="p in platformData" :key="p.id" :value="p.id" :label="p.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="游戏组">
        <el-select v-model="gameGroupId" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in GAME_GROUPS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="游戏">
        <el-select v-model="gameId" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in GAMES" :key="item.id" :label="item.name" :value="item.id" style="width: 260px"> </el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="媒体">
        <el-select v-model="mediaId" clearable collapse-tags filterable placeholder="全部" style="width: 120px" @change="handleMedia">
          <el-option v-for="item in MEDIAS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="投放位">
        <el-select v-model="AdvertPositionId" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in AdvertPositionData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="优化目标" label-width="60">
        <el-select v-model="optimizationType" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in optimizationData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="深度优化" label-width="60">
        <el-select v-model="deepOptimizationType" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in deepOptimizationData" :key="item.id" :value="item.id" :label="item.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="项目组">
        <el-select v-model="projectGroupId" :popper-append-to-body="false" multiple collapse-tags filterable placeholder="全部">
          <el-option v-for="pro in PROJECT_GROUP" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="人员">
        <el-select v-model="opId" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
      <ElFormItem label="管理人员" label-width="60">
        <el-select v-model="managerId" clearable collapse-tags filterable placeholder="全部" style="width: 120px">
          <el-option v-for="item in PTOM_USERS" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select>
      </ElFormItem>
      <ElButton type="primary" @click="sendEvent">查询</ElButton>
    </ElForm>
  </div>
</template>
<script>
import { isArray } from '@/common/js/utils'
import { optimization, deepOptimization } from './detail.data'
import { initPageData, PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS } from '@/data/global-opts'
import { transferTaskQueryConditions } from '@/views/download-center/data/utils.js'

// 当前页面需要的下拉数据项 ref: src\data\global-opts.js
const PAGE_REQUIRED_OPTS = initPageData([PROJECT_GROUP, MEDIA_POSITION, MEDIA_ACCOUNTS, GAME_GROUPS, GAMES, MEDIAS, PTOM_USERS])

export default {
  name: 'detailFilter',
  computed: {
    ...PAGE_REQUIRED_OPTS,

    // 广告位列表数据，根据媒体筛选
    AdvertPositionData() {
      let data = []
      if (this.mediaId && parseInt(this.mediaId) > 0) {
        data = this.MEDIA_POSITION.filter((ret) => ret.mediaId === parseInt(this.mediaId))
      }
      return data
    },

    optimizationData() {
      let data = []
      if (this.mediaId && parseInt(this.mediaId) > 0) {
        data = optimization.filter((ret) => ret.media === parseInt(this.mediaId))
      }
      return data
    },
    deepOptimizationData() {
      let data = []
      if (this.mediaId && parseInt(this.mediaId) > 0) {
        data = deepOptimization.filter((ret) => ret.media === parseInt(this.mediaId))
      }
      return data
    }
  },
  data() {
    return {
      gameId: '', // 游戏id
      gameGroupId: '', // 游戏组id
      projectGroupId: [], // 项目组id
      mediaId: '', // 媒体id
      AdvertPositionId: '', // 广告位id
      optimizationType: '',
      deepOptimizationType: '',
      opId: '', // 人员id
      managerId: '', // 管理人员
      accountId: [], // 账号
      platform: '',
      platformData: [
        { id: 1, name: 'Andriod' },
        { id: 2, name: 'iOS' }
      ]
    }
  },
  methods: {
    /**
     * @description: 添加导出任务时转化查询条件为可读的字符串
     * @param {*} extraParams
     * @param {*} pageType
     * @return {*}
     */
    getTransferedTaskQueryConditions(extraParams, pageType) {
      return transferTaskQueryConditions.call(this, { ...this.buildParams(), ...extraParams }, pageType)
    },
    buildParams() {
      return {
        adAccountIdStr: isArray(this.accountId) && this.accountId.length ? this.accountId.join(',') : undefined,
        gameId: this.gameId === '' ? undefined : this.gameId,
        gameGroupId: this.gameGroupId === '' ? undefined : this.gameGroupId,
        opId: this.opId === '' ? undefined : this.opId,
        managerId: this.managerId === '' ? undefined : this.managerId,
        projectGroupOpIds: isArray(this.projectGroupId) && this.projectGroupId.length ? this.projectGroupId.join(',') : undefined,
        mediaId: this.mediaId === '' ? undefined : this.mediaId,
        platform: this.platform === '' ? '0' : this.platform,
        advPositionId: this.AdvertPositionId === '' ? undefined : this.AdvertPositionId,
        optimizationType: this.optimizationType === '' ? undefined : this.optimizationType,
        deepOptimizationType: this.deepOptimizationType === '' ? undefined : this.deepOptimizationType
      }
    },
    sendEvent(type) {
      const params = this.buildParams()
      if (type === 'save') this.$emit('on-save', params)
      else this.$emit('on-change', params)
    },
    saveFilter() {
      this.sendEvent('save')
    },
    handleMedia() {
      this.AdvertPositionId = ''
      this.optimizationType = ''
      this.deepOptimizationType = ''
    }
  }
}
</script>
